const relative = new Intl.RelativeTimeFormat('en', { numeric: 'auto', style: 'short' })

/** "3 min ago", "in 12 sec". */
export function formatRelative(iso: string, now: number = Date.now()): string {
  const seconds = Math.round((new Date(iso).getTime() - now) / 1000)
  const abs = Math.abs(seconds)
  if (abs < 5) return 'just now'
  if (abs < 60) return relative.format(seconds, 'second')
  if (abs < 3600) return relative.format(Math.round(seconds / 60), 'minute')
  if (abs < 86_400) return relative.format(Math.round(seconds / 3600), 'hour')
  return relative.format(Math.round(seconds / 86_400), 'day')
}

const timestamp = new Intl.DateTimeFormat('en', { dateStyle: 'medium', timeStyle: 'medium' })

export function formatTimestamp(iso: string): string {
  return timestamp.format(new Date(iso))
}

const dateTimeShort = new Intl.DateTimeFormat('en', { dateStyle: 'medium', timeStyle: 'short' })
export const formatCreated = (iso: string): string => dateTimeShort.format(new Date(iso))

/**
 * A count with its noun, the way a label reads it: "1 Job", "5 Players".
 * The plural is the noun plus "s" unless one is given.
 */
export function countOf(count: number, noun: string, plural = `${noun}s`): string {
  return `${count} ${count === 1 ? noun : plural}`
}

const day = new Intl.DateTimeFormat('en', { day: 'numeric', month: 'long', year: 'numeric' })

/**
 * A calendar day with its month spelled out — "October 31, 2026" — so no
 * reader has to guess whether 09/10 is September or October.
 */
export function formatDay(iso: string): string {
  return day.format(new Date(iso))
}
